import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Create axios instance for admin API calls with automatic JWT attachment
const adminApi = axios.create({
  baseURL: BACKEND_URL,
});

// Request interceptor: attach Bearer token from localStorage
adminApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor: handle 401 (expired/invalid token) - redirect to login
adminApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid - clear it
      localStorage.removeItem('admin_token');
      // Redirect to login if not already there
      if (!window.location.pathname.includes('/admin') || window.location.pathname.includes('/admin/dashboard')) {
        window.location.href = '/admin';
      }
    }
    return Promise.reject(error);
  }
);

export default adminApi;
